import React from 'react';
import { useState, useEffect } from 'react';

import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography, Tab } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';


import studentsImage from '../assets/racl_students.png';
import raclCampingImage from '../assets/racl_2014camping_1280.jpg';

const  Student = () => {

  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('./test.html') // Path relative to public folder
      .then(response => response.text())
      .then(data => setContent(data));
  }, []);



  return (
    // <>
    //   <div>
    //     <div >
    //       <br/>
    //       <br/>
    //       <br/>
    //       <br/>
    //       <br/>
    //       <br/>
        
    //       <p>                      
    //           学校学生服务 主页面 (新建中...)
    //           <div dangerouslySetInnerHTML={{ __html: content }} />
    //       </p>

    //     </div>

   
    //   </div>
      
     
    // </>
        <>
        <Box height={100} />

        <Grid container spacing={0} alignItems="center" justify="left">
            <Grid item xs={2} />
            <Grid item xs={8}>

                <Card>
                <CardHeader title='学校学生服务 主页面 (创建中...)'/>
                <CardContent>


                    <Box textAlign={'center'}>
                        <img src={studentsImage} alt="Students" style={{ maxWidth: '100%', height: 'auto' }} />
                    </Box>
                    <br />
                    <br />
                    <br />
                    <Box textAlign={'left'}>
                        {/* <div dangerouslySetInnerHTML={{ __html: content }} /> */}
                    </Box>

                    <Box textAlign={'left'}>
                                <a href="/school-calendar" >学校日历</a>
                    </Box>

                    </CardContent>
                </Card>


            </Grid> 
            <Grid item xs={2} />
            <Grid item xs={8}>
                
            </Grid>
        </Grid>
        
        <Box height={80} />
        </>
        )
    }

export default Student